module.exports = __webpack_public_path__ + "img/icon-print-layout-horizontal.03985996.svg";